import React from "react";
import PropTypes from "../../utils/propTypes";
import Image from "./Image";
import {canUseWebP} from "../../utils/Utilities";

class ImageWithLoader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false
    };
  }

    reload = () => {
        this.setState({ loaded: false });
    };

    handleLoad = () => {
    this.setState({ loaded: true });
  };

  render() {
    const { src, alt, width, height, noWebp, style } = this.props;
    const { loaded } = this.state;

      if(src){
          if(src && src.includes("base64")){
              // Base 64 nothing to do
          }else{
              if(!noWebp){
                  if(canUseWebP()){
                      src = src+"?webp=true"
                  }else{
                      src = src+"?webp=false"
                  }
              }
          }
      }

      return (
      <div style={{ position: "relative", width: width, height: height, ...style }}>
          {!loaded && (
          <div
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              background: "#e0e0e0",
              animation: "pulse 1.5s infinite"
            }}
          />
        )}

        {/* Image */}
        <img
          src={src}
          alt={alt}
          onLoad={this.handleLoad}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: loaded ? 1 : 0,
            transition: "opacity 0.3s ease"
          }}
        />
      </div>
    );
  }
}

ImageWithLoader.propTypes = {
    style: PropTypes.any,
    src: PropTypes.string,
    className:PropTypes.any,
    noWebp:PropTypes.bool,
    alt:PropTypes.bool,
    width: PropTypes.string,
    height: PropTypes.string,
};


export default ImageWithLoader;